import { SxProps } from '@mui/material';

export const ProductToExhaustTextSx: SxProps = {
	display: 'flex',
	alignItems: 'center',
	color: '#AD3809',
	marginTop: '0',
	fontWeight: 'normal',
	letterSpacing: '0',
	fontSize: '15px',
};
